module.exports = __webpack_public_path__ + "static/NightInTheWoods7-15cb1e088b1177444ec6f2be69584513.webp";